var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z",
    fill: "url(#paint0_linear_5590_482)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9743 44.8313C38.182 44.8313 44.8356 38.1913 44.8356 30.0006C44.8356 21.8098 38.182 15.1699 29.9743 15.1699C22.1875 15.1699 15.7995 21.1466 15.165 28.7539H34.808V31.2472H15.165C15.7995 38.8547 22.1875 44.8313 29.9743 44.8313Z",
    fill: "url(#paint1_linear_5590_482)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5590_482",
    x1: 13.125,
    y1: -0.00000223867,
    x2: 52.4234,
    y2: 25.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#936707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5590_482",
    x1: 21.6555,
    y1: 15.1699,
    x2: 41.0853,
    y2: 27.8627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.7bdeebad8932c5f4b3151daf7539ace3.svg";
export { ForwardRef as ReactComponent };